export const useQueryParams = (urlSearch) => {
  const result = {};
  if (!urlSearch) {
    return null;
  }
  const urlSearchParams = new URLSearchParams(urlSearch);
  urlSearchParams.forEach((value, key) => {
    result[key] = value;
  });
  return result;
};
